import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { REPORT_URL_PARAMS, REPORT_IDS } from '../../constants/constants';

const ProjectReports = ({ projectId }) => {

    return (
        <div className="project-reports-section">
            <div className="row no-gutters identifier-header">
                <div className="dashboard-widget-title">Project Reports</div>
            </div>

            <div className="row">
                <div className="col-6">
                    <div className="card mt-2">
                        <div className="card-title card-header">
                            Summary Reports
                        </div>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item">
                                <Link 
                                    to={{ pathname: `/reports/${REPORT_IDS.ProjectCrosstab}`, search: `?${REPORT_URL_PARAMS.ProjectId}=${projectId}` }} 
                                    target="_blank">
                                    Project Crosstab
                                </Link>
                            </li>
                            <li className="list-group-item">
                                <Link 
                                    to={{ pathname: `/reports/${REPORT_IDS.ProjectDeployment}`, search: `?${REPORT_URL_PARAMS.ProjectId}=${projectId}` }} 
                                    target="_blank">
                                    Project Deployment
                                </Link>
                            </li>
                            <li className="list-group-item">
                                <Link 
                                    to={{ pathname: `/reports/${REPORT_IDS.LocationSummaryPerProject}`, search: `?${REPORT_URL_PARAMS.ProjectId}=${projectId}` }} 
                                    target="_blank">
                                    Location Summary per Project
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-6">
                    <div className="card mt-2">
                        <div className="card-title card-header">
                            Data Exports
                        </div>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item">
                                <Link 
                                    to={{ pathname: `/reports/${REPORT_IDS.ProjectLocationsList}`, search: `?${REPORT_URL_PARAMS.ProjectId}=${projectId}` }} 
                                    target="_blank">
                                    Project Locations
                                </Link>
                            </li>
                            <li className="list-group-item">
                                <Link 
                                    to={{ pathname: `/reports/${REPORT_IDS.ProjectTasksList}`, search: `?${REPORT_URL_PARAMS.ProjectId}=${projectId}` }} 
                                    target="_blank">
                                    Project Tasks List
                                </Link>
                            </li>
                            <li className="list-group-item">
                                <Link 
                                    to={{ pathname: `/reports/${REPORT_IDS.ProjectLocationsList}`, search: `?${REPORT_URL_PARAMS.ProjectId}=${projectId}` }} 
                                    target="_blank">
                                    Project Locations
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

ProjectReports.propTypes = {
    projectId: PropTypes.number.isRequired
};

export default ProjectReports;